import axios from 'axios';
import { polusBaseUrl, uwBaseUrl, POST, GET } from '../../../utils/axios-interceptor';
import { getTimeStamp } from '../../../utils/dateUtils';

export function fetchBankStatementDataService() {
    return axios({
        baseURL: polusBaseUrl,
        url: API_ENDPOINTS.FETCH_BANK_STMT_DATA,
        method: POST,
        data: {
            requestId: getTimeStamp(),
            // "endDate" : "2024-01-31",
            csv: false,
        },
    });
}

export function downloadBankStatementSummaryService(investeeOrgId: string, dataType: string = 'summary') {
    return axios({
        baseURL: uwBaseUrl,
        url: API_ENDPOINTS.DOWNLOAD_BANK_STMT_SUMMARY,
        method: 'POST',
        params: {
            investeeOrgId,
            dataType,
        },
        data: {
            requiredFiles: ['BANK_RAW', 'BANK_CLASSIFIED', 'BANK_PIVOT', 'SUMMARY_BANK_STATEMENT', 'BANK_ANALYSIS_REPORTS'],
        },
        responseType: 'blob',
    });
}

const API_ENDPOINTS = {
    FETCH_BANK_STMT_DATA: '/data/bankStatementData',
    DOWNLOAD_BANK_STMT_SUMMARY: '/mis/download',
};
